<template>
  <div style="background-color:#f9f9f9;background-image:url('/backgrounds/iso.svg');border-bottom:1px solid #ddd;">
    <div class="container" style="background-color:#f5f5f5;border-right:1px solid #eee;border-left:1px solid #eee;">
      <div class="row align-items-center" style="padding:3px 0px 3px 0px;;border-bottom:1px solid #ddd;" v-if="(profile && profile.is_ldr)">
        <div class="col-12">
            <router-link :to="{ name: 'home' }" class="ldr-home-link">
              <img src="../../assets/ldr-logo.png" style="height:29px;margin-bottom:4px;margin-top:5px;margin-right:10px;float:none;f">
            </router-link>
            <span style="color:#888;font-size:0.85em;font-weight:normal;padding-top:7px;">Powered by the Landscape Diagnostic service. <!--Questions, comments, feedback? <a href="mailto:info@mapworks.nl">Get in touch.</a>--></span>
        </div>
      </div>
      <div class="row align-items-center" style="padding:5px 0px 5px 0px;">
        <div class="col-3">
            <router-link :to="{ name: 'home' }">
              <template v-if="(profile && profile.is_ldr)">                
                <img src="../../assets/whitelabels/idh.png" style="height:50px;padding-top:0px;margin-top:10px;margin-bottom:10px;">
                <img src="../../assets/whitelabels/svi_sm.png" style="height:85px;margin-left:30px;" v-if="(profile && ((profile.username == 'svi') || (profile.username=='idh-madagascar')))">
              </template>
              <template v-else>
                <img id="logo" src="../../assets/geofolio-logo.svg" style="height:45px;margin-bottom:4px;margin-top:10px;margin-bottom:10px;">
              </template>

            </router-link>


        </div>
        <div class="col-9 text-right">
            <div style="font-size:1.2em;padding-top:3px;color:#666;">
               <div v-if="(profile && (profile.is_public == false))">
                <span style="margin-left:5px;background-color:white;border:1px solid #ccc;border-radius:5px; padding:5px 7px;margin-right:15px;"><div style="width:13px;height:13px;margin-right:5px;display:inline-block;background-color:green;border-radius:10px;"></div>Logged in as {{ profile.username }}</span>

                  <template v-if="(profile && profile.is_ldr)">
                    <a href="/login/ldr" v-if="profile" v-on:click.prevent="logOut('login-ldr')">Logout</a> 
                  </template>
                  <template v-else>
                    <a href="/logout" v-if="profile" v-on:click.prevent="logOut('home')">Logout</a> 
                  </template>

               </div>
              <div v-else>
                  
                   Follow us via <a href="https://twitter.com/geofolio">@geofolio</a> for news and updates
                
                  <!-- Please <router-link :to="{ name: 'login' }">login</router-link> to keep track of your areas of interest. -->

                  <!--
                <span style="margin-left:5px;background-color:white;border:1px solid #ccc;border-radius:5px; padding:5px 7px;margin-right:0px;"><div style="width:13px;height:13px;margin-right:5px;display:inline-block;background-color:#ccc;border-radius:10px;"></div>You are not logged in</span>-->
               </div>
               
            </div>
        </div> 
      </div>
    </div>



  </div>
</template>


<script>
  
  export default {
    name: 'mainheader',
    components: {
    },
    computed: {
        profile() {
            if(this.$store.state.profile) {
                return this.$store.state.profile
              } else {
                return this.$store.state.profile_pub;
              }
        }
    },
    methods: {
      logOut(dest='home') {
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/logout", null, { headers: headers })
           .then(response => {
                this.$store.commit('profile', response.data.profile)
                this.$store.commit('profile_pub', response.data.profile_pub)
                this.$router.push({name: dest})
           })
           .catch(error => {
               console.log("An error occurred while logging out.")
           })
      }
    }
  }
</script>

<style>
    a.ldr-home-link {
      filter:grayscale(0.5);
      opacity:0.5;
    }
    a.ldr-home-link:hover {
      filter:grayscale(0);
      opacity:1;
    }
</style>